var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEditInput(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 25,
    viewBox: "0 0 28 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.711 4.21068L22.888 7.03335M21.754 1.72401L13.1635 9.36001C12.7196 9.75401 12.4169 10.256 12.2935 10.8027L11.5 14.3333L15.472 13.6267C16.087 13.5173 16.651 13.2493 17.095 12.8547L25.6855 5.21868C25.9436 4.98922 26.1484 4.7168 26.2881 4.417C26.4278 4.11719 26.4997 3.79586 26.4997 3.47135C26.4997 3.14684 26.4278 2.8255 26.2881 2.5257C26.1484 2.22589 25.9436 1.95348 25.6855 1.72401C25.4274 1.49455 25.1209 1.31253 24.7836 1.18835C24.4463 1.06416 24.0848 1.00024 23.7197 1.00024C23.3547 1.00024 22.9932 1.06416 22.6559 1.18835C22.3186 1.31253 22.0121 1.49455 21.754 1.72401V1.72401Z",
    stroke: "#55ACD8",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23.5 17.0001V21.0001C23.5 21.7073 23.1839 22.3856 22.6213 22.8857C22.0587 23.3858 21.2956 23.6667 20.5 23.6667H4C3.20435 23.6667 2.44129 23.3858 1.87868 22.8857C1.31607 22.3856 1 21.7073 1 21.0001V6.33341C1 5.62617 1.31607 4.94789 1.87868 4.4478C2.44129 3.9477 3.20435 3.66675 4 3.66675H8.5",
    stroke: "#55ACD8",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditInput);
export default __webpack_public_path__ + "static/media/edit-input.b24202018dca3beaf1cf0ad07877b959.svg";
export { ForwardRef as ReactComponent };